import type { Sport } from '@geosport/shared';

const ICON: Record<Sport, { emoji: string; label: string }> = {
  football: { emoji: '⚽', label: 'Football' },
  cricket: { emoji: '🏏', label: 'Cricket' },
  f1: { emoji: '🏎️', label: 'Formula 1' },
  tennis: { emoji: '🎾', label: 'Tennis' },
  rugby: { emoji: '🏉', label: 'Rugby' },
  golf: { emoji: '⛳', label: 'Golf' },
  athletics: { emoji: '🏃', label: 'Athletics' },
  other: { emoji: '🏅', label: 'Sport' },
};

export function SportIcon({ sport, className = '' }: { sport: Sport; className?: string }) {
  const { emoji, label } = ICON[sport];
  return (
    <span role="img" aria-label={label} title={label} className={className}>
      {emoji}
    </span>
  );
}

export const sportLabel = (sport: Sport): string => ICON[sport].label;
